import { GroupedItems, GroupedItemsList } from '../interfaces'
import GroupedItemList from './GroupedItemList'

interface DropdownGroupedItemListProps {
  items: GroupedItemsList
  classes: string
}

const DropdownGroupedItemList = ({ classes, items }: DropdownGroupedItemListProps) =>
  <div className={classes}>
    {items.map((item: GroupedItems) =>
      <GroupedItemList
        key={item.groupName}
        groupName={item.groupName}
        items={item.items}
      />)}
  </div>

export default DropdownGroupedItemList
